import { useRef } from 'react';

import { useDispatch } from 'react-redux';
import { authAction } from '../../store/auth-slice';

import classes from './FormSection.module.scss';

export default function FormSection({
  isFormSignup,
  isSignup,
  t,
  language,
  closeHandler,
}) {
  const nameRef = useRef();
  const passwordRef = useRef();
  const emailRef = useRef();

  const dispatch = useDispatch();

  const loginHandler = (event) => {
    event.preventDefault();
    dispatch(
      authAction.logIn({
        token: 'this is a token',
        userID: 'user 0',
        email: emailRef.current.value || 'email@aut.ac.ir',
        name: nameRef.current ? nameRef.current.value : 'someone', // اگر لاگ این کردیم باید این را از بک اند بگیریم
      })
    );
    closeHandler();
  };

  const formTypeClass = () => {
    if (isFormSignup) {
      return isSignup ? classes.signupVisible : classes.loginVisible;
    }
    return isSignup ? classes.formForSignup : classes.formForLogin;
  };

  return (
    <form
      className={`${classes.form} ${classes['form-' + language]}`}
      onSubmit={loginHandler}
    >
      <ul className={formTypeClass()}>
        {isFormSignup && (
          <li>
            <input type="text" placeholder={t('name')} ref={nameRef} />
          </li>
        )}
        <li>
          <input type="email" placeholder={t('email')} ref={emailRef} />
        </li>
        <li>
          <input
            type="password"
            placeholder={t('password')}
            ref={passwordRef}
          />
        </li>
      </ul>
      <button type="submit">{t('done')}</button>
      {!isFormSignup && (
        <a href="https://www.google.com">{t('forget my password')}</a>
      )}
    </form>
  );
}
